import { render, staticRenderFns } from "./HomepageBalloon.vue?vue&type=template&id=2cbc0823"
import script from "./HomepageBalloon.vue?vue&type=script&lang=js"
export * from "./HomepageBalloon.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports